import { Component, OnInit } from '@angular/core';
import { SEOService } from 'src/app/shared/seo.service';

@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.css']
})
export class WidgetComponent implements OnInit {
  ad = '';
  mail = '';
  konu = 'Kurum demosu istiyorum';
  mesaj = '';

  constructor(private seoService: SEOService) {}

  ngOnInit(): void {
    this.setMeta();
  }

  gonder() {
    const konu = encodeURIComponent(this.konu);
    const govde = encodeURIComponent(
      `Ad: ${this.ad}\nE-posta: ${this.mail}\n\n${this.mesaj}`
    );
    window.location.href = `mailto:help@pratiu.com?subject=${konu}&body=${govde}`;
  }

  setMeta() {
    const title = 'pratiu - İletişim';
    this.seoService.updateDescription(title);
    this.seoService.updateKeywords('Pratiu İletişim, İletişim');
    this.seoService.updateTitle(title);
  }
}
